import React, { Component } from "react";
import Registrar from "./Registrar";



function Monedero(props) {

    var card_number = {
        color: props.datos.letra,
        marginTop: '-140px',
        fontSize: '24px',
        'font-family': 'PT Mono, monospace',
        'align-items': 'flex-end',
        'letter-spacing': '13px',
    }

    if (props.datos.id > 0) {
        return (
            <div className="mt-5 text-center">
                <p className="h6">Hola <b>{props.datos.nombre}</b> tienes:</p>
                <p className="text-success"><h5>{props.datos.saldo} Puntos </h5></p>
                <p className="h6">Tarjeta: <b>{props.datos.tipo_tarjeta}</b> -  Clasificación: <b>{props.datos.clasificacion}</b></p>
                <img src={props.datos.img} height="280" /> <br />
                <br className="mb-2" />
                <p style={card_number} className="mb-2">{props.datos.tarjeta}</p>

            </div>
        )
    } else {
        return (
            <div></div>
        )
    }
}

export default class Consultar extends Component {


    state = {
        id: -1,
        busqueda: '',
        nombre: '',
        saldo: 0,
        img: '',
        letra: 'white',
        tarjeta: '0',
        tipo_tarjeta: '',
        clasificacion: '',
        loading: false
    }

    consultaDatos = e => {
        e.preventDefault();
        this.setState({
            loading: true,
            saldo: 0
        });

        let tp_cl = '';
        let color = 'white';
        fetch("http://monedero.ipsservicios.com.mx/consultar.php",
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: "POST",
                body: JSON.stringify({
                    'accion': 'puntos',
                    'nombre': this.state.busqueda
                })
            })
            .then(res => res.json()).then(result => {
                console.log(result);
                if (result) {
                    if (result.CLASI === 1) {
                        tp_cl = './plus.jpeg'
                    } else if (result.CLASI === 3) {
                        tp_cl = './student.jpeg'
                        color = 'red';
                    } else if (result.CLASI === 4) {
                        tp_cl = './business.jpeg'
                    }
                    this.setState({
                        loading: false,
                        id: result.MONEDERO_ID,
                        saldo: result.SALDO,
                        nombre: result.NOMBRE,
                        img: tp_cl,
                        letra: color,
                        tarjeta: result.MONEDERO,
                        clasificacion: result.CLASIFICACION,
                        tipo_tarjeta: result.TIPO
                    });
                }
                if (result.MONEDERO_ID === null || result.MONEDERO_ID === '') {
                    this.setState({
                        loading: false,
                        id: 0
                    });
                }
            }).catch(error => {
                console.log(error);
            });

    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() {

        return (<div>
            <form onSubmit={this.consultaDatos}>
                <div className="input-group">
                    <input type="text" name="busqueda" required onChange={this.onChange} className="form-control" placeholder="Escriba su monedero o número de teléfono!" aria-label="Escriba el monedero o teléfono a buscar.!" aria-describedby="button-addon2" />
                    <input value="Consultar" className="btn btn-primary" type="submit" id="button-addon2" />
                    <button type="button" className="btn btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        Registrar </button>
                </div>
            </form>
            {
                (this.state.loading) ?
                    <div className="spinner-border float-lg-end" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    :
                    <div></div>
            }
            {
                (this.state.id === 0) ?
                    <div className="alert alert-danger d-flex align-items-center mt-4" role="alert">
                        <div>
                            No se encontraron datos!!
                        </div>
                    </div>
                    :
                    <div></div>
            }
            <br />
            <Monedero datos={this.state} />
            <div className="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Registrarse</h5>
                        </div>
                        <div className="modal-body">
                            <Registrar />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }


}
